export const DEFAULT_TEAM_CONTENT = {
  intro:
    "Ons team bestaat uit een enthousiaste groep leerkrachten en onderwijsondersteuners (RT), allemaal met een aantekening voor Freinet onderwijs. Daarnaast hebben we een vakleerkracht voor gym.",
  imageS3Key: "media/images/_MG_1280.JPG",
  imageAlt: "Team De Windroos",
  groups: [
    {
      key: "leiding",
      title: "Schoolleiding en kwaliteit",
      members: [
        { name: "Jonneke Reichert", role: "Directeur" },
        {
          name: "Tilly Baas",
          role: "Kwaliteitscoördinator",
          otherRoles: "Schoolopleider",
        },
      ],
    },
    {
      key: "leerkrachten",
      title: "Groepen en leerkrachten",
      members: [
        {
          name: "Nienke Jubbega",
          role: "Groep 1/2",
          otherRoles: "Bouwcoördinator onderbouw",
        },
        { name: "Marjolein", role: "Groep 1/2" },
        {
          name: "Lianne Dorrestijn",
          role: "Groep 3",
          otherRoles: "ICT-coördinator",
        },
        { name: "Peter", role: "Groep 3" },
        {
          name: "Isabelle",
          role: "Groep 4",
          otherRoles: "Interne vertrouwenspersoon en aanspreekpunt anti-pesten",
        },
        {
          name: "Hanneke Nijenhuis",
          role: "Groep 4",
          otherRoles: "Lid MR",
        },
        { name: "Loes Vermaeten", role: "Groep 5/6", otherRoles: "Nieuwbouw" },
        { name: "Lucas", role: "Groep 5/6" },
        {
          name: "Jeroen",
          role: "Groep 6/7 en groep 7/8",
          otherRoles: "Inclusie en neurodiversiteit",
        },
        {
          name: "Noortje van Lieshout",
          role: "Groep 6/7",
          otherRoles: "Schoolopleider, Freinet- en burgerschapscoördinator",
        },
        {
          name: "Sharon Reimert",
          role: "Groep 7/8",
          otherRoles: "Bouwcoördinator bovenbouw, aandachtsfunctionaris",
        },
      ],
    },
    {
      key: "ondersteuning",
      title: "Ondersteuning",
      members: [
        {
          name: "Marian van Heerde",
          role: "Onderwijsondersteuner/RT",
          otherRoles: "Lid MR, coördinator Gezonde School",
        },
        {
          name: "Levina Verhoef",
          role: "Onderwijsondersteuner/RT",
          otherRoles: "Inclusie en neurodiversiteit",
        },
        { name: "Paul Seelen", role: "Conciërge" },
        { name: "Jorrit", role: "Assistent conciërge" },
        { name: "Maaike Balk", role: "Freinetondersteuner" },
        { name: "Anouschka", role: "Vrijwillig ondersteuner" },
        { name: "Rita", role: "Onderwijsondersteuning" },
        { name: "Basima", role: "Onderwijsondersteuning" },
        { name: "Gitta", role: "Onderwijsondersteuning" },
        { name: "Hanneke M.", role: "Onderwijsondersteuning" },
      ],
    },
  ],
  portraits: [
    {
      key: "jorrit",
      name: "Jorrit",
      role: "Assistent-conciërge",
      intro:
        "Sinds 2018 helpt Jorrit kinderen en collega's met alles wat er op een schooldag praktisch nodig is. Hij brengt ervaring van andere scholen mee, zorgt voor structuur en maakt met zijn gezelligheid de dag voor veel mensen net wat leuker.",
      questions: [
        {
          question: "Hoe ben je op De Windroos beland?",
          answer:
            "Via mijn tweelingzus. Zonder haar was ik nooit in het onderwijs terechtgekomen. Ik had ook nog nooit gesolliciteerd. Zij heeft zich ervoor ingespannen dat ik bij haar op school aan de slag kon. Daarna ben ik op een andere school gaan werken en via schooldirecteuren bij De Windroos terechtgekomen. De directeur wilde me heel graag hebben. Dat was in 2018.",
        },
        {
          question: "Hoe kijk je terug op je tijd bij De Windroos?",
          answer:
            "Ik heb een hoop geleerd. In het begin moest ik erg wennen aan de reuring op school, maar de werksfeer en de teamleden zijn erg leuk. Het bleek een schot in de roos.",
        },
        {
          question: "Wat maakt De Windroos speciaal?",
          answer:
            "Ik krijg volop de kans om mezelf te zijn. Ze staan overal voor open: geen vraag is te gek. Alles mag er zijn en ik kan bij iedereen terecht. Dat maakt deze werkplek speciaal.",
        },
        {
          question: "Wat brengt het jou?",
          answer:
            "Het helpt mij om structuur aan te brengen in mijn week. Het is ook heel fijn dat er geen druk op staat, waardoor ik niet echt werkdruk ervaar.",
        },
        {
          question: "Wat voeg jij toe?",
          answer:
            "Ik breng veel ervaring mee van andere scholen waar ik conciërge ben geweest. Daardoor weet ik eigenlijk best veel. Verder breng ik gezelligheid en ben ik er iedere dag. Kinderen komen graag bij mij voor een pleister of een ander praktisch probleem.",
        },
        {
          question: "Wat zouden mensen nog over jou moeten weten?",
          answer:
            "Ik heb veel verre reizen gemaakt: begeleide reizen met jongerengroepen. De laatste reis was naar Suriname. Dat was een hartstikke mooie ervaring!",
        },
      ],
    },
    {
      key: "anouschka",
      name: "Anouschka",
      role: "Vrijwillig ondersteuner",
      intro:
        "Anouschka kent De Windroos als oud-leerling én als vrijwillig ondersteuner. Ze helpt bij de kleuters, ondersteunt rondom de maandvieringen en brengt met haar aandacht voor kinderen en collega's veel vertrouwdheid en gezelligheid in school.",
      questions: [
        {
          question: "Hoe ben je op De Windroos beland?",
          answer: "Ik heb hier vroeger zelf op school gezeten. Ik vind het superleuk om hier nu te werken.",
        },
        {
          question: "Hoe vind je het werken op De Windroos?",
          answer:
            "Leuk. Het werken met de kinderen en het team is heel fijn. Ook de koffieronde is leuk om te doen. De juffen houden van koffie en thee en ik vind het leuk om iemand blij te maken.",
        },
        {
          question: "Wat maakt De Windroos speciaal?",
          answer:
            "De manier waarop hier met kinderen wordt omgegaan, dat ik hier zelf op school heb gezeten en dat het een mooie, vertrouwde school is.",
        },
        {
          question: "Wat levert het jou op?",
          answer:
            "Het brengt mij een goede toekomst en ik leer er veel van: hoe ik met kinderen omga, hoe ik van hen leer en hoe zij ook weer van mij leren.",
        },
        {
          question: "Wat breng jij de school?",
          answer:
            "Ik help bij de kleuters, maak schoon, zet de maandviering klaar en breng koffie en thee rond. Daar wordt de school ook blij van. En ik klets veel, dus ik breng veel gezelligheid.",
        },
        {
          question: "Wat zouden mensen nog over jou moeten weten?",
          answer:
            "Ik sport en fiets veel. Ik doe leuke dingen met vrienden, ga graag een dagje uit en sta met veel bekende mensen op de foto. Ook volg ik een EHBO-cursus, zodat ik nog beter leer hoe ik kinderen kan helpen.",
        },
      ],
    },
  ],
};

export function cloneTeamContent(content = DEFAULT_TEAM_CONTENT) {
  return {
    ...content,
    groups: content.groups.map((group) => ({
      ...group,
      members: group.members.map((member) => ({ ...member })),
    })),
    portraits: (content.portraits || []).map((portrait) => ({
      ...portrait,
      questions: portrait.questions.map((question) => ({ ...question })),
    })),
  };
}

export function parseTeamContent(content) {
  try {
    const parsed = typeof content === "string" ? JSON.parse(content) : content;
    if (!parsed || !Array.isArray(parsed.groups) || parsed.groups.length === 0) return null;
    return {
      intro: typeof parsed.intro === "string" ? parsed.intro : DEFAULT_TEAM_CONTENT.intro,
      imageS3Key:
        typeof parsed.imageS3Key === "string"
          ? parsed.imageS3Key
          : DEFAULT_TEAM_CONTENT.imageS3Key,
      imageAlt:
        typeof parsed.imageAlt === "string" ? parsed.imageAlt : DEFAULT_TEAM_CONTENT.imageAlt,
      groups: parsed.groups,
      portraits: Array.isArray(parsed.portraits)
        ? parsed.portraits
        : DEFAULT_TEAM_CONTENT.portraits,
    };
  } catch {
    return null;
  }
}
